import * as React from "react"
import dummy from "../../images/dummy.png"
import Layout from "../../components/layout/layout";
import {Link} from "gatsby";
import fab from "../../images/fab.webp";

import flame from "../../images/products/fab/flameretardant.jpg"
import laminated from "../../images/products/fab/laminated.jpg"
import scrims from "../../images/products/fab/mattressscrims.jpg"
import hydro from "../../images/products/fab/hydrophilic.jpg"
import microporous from "../../images/products/fab/microporous.jpg"
import perforated from "../../images/products/fab/perforated.jpg"
import pocket from "../../images/products/fab/pocketsprings.jpg"
import ppspun from "../../images/products/fab/ppspunbond.jpg"
import uvprot from "../../images/products/fab/uvprotected.jpg"

const FabTechPage = () => {
    return (
        <Layout isHomePage={false} pageName={"Fab Tech"}>
            <section className="pb-5 wrapper bg-light">
                <div className="container py-md-12">
                    <div className="py-5 row gx-lg-8 gx-xl-12 gy-10 align-items-center">
                        <div
                            data-sal="flip-left"
                            data-sal-delay="100"
                            data-sal-easing="easeInExpo"
                            className="pt-4 row grid-view col-lg-5 d-flex position-relative mx-auto"
                        >
                            <div className="img-blob rounded">
                                <img src={fab} alt=""/>
                            </div>
                        </div>
                        <div
                            data-sal="slide-left"
                            data-sal-delay="200"
                            data-sal-easing="easeInExpo"
                            className="col-md-6 d-flex flex-column justify-content-center align-items-center">
                            <h2 className="display-2">
                                Fabric Properties
                            </h2>
                            <ul className="icon-list fs-18 bullet-primary">
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        High Strength
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Non - Conductive
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Foldable
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Heat Sealable
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Economical &amp; Cost effective for bag making
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Soft Hand feel
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Non - toxic, no smell, soft for skin
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Tear Resistant
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Anti – Bacterial
                                    </span>
                                </li>
                                <li>
                                    <span>
                                        <i className="bi bi-check2-circle text-orange"/>
                                    </span>
                                    <span>
                                        Abrasions Resistant
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <p
                        data-sal="fade"
                        data-sal-delay="300"
                        data-sal-easing="easeInExpo"
                        className="lead fs-23 my-3">
                        <i className="text-orange bi bi-arrow-right-short"/>
                        Our fabrics are made from 100% original PP granules using the latest technology. Our fabrics are
                        strong, safe,
                        free of toxins, and are technically engineered to suit a wide array of applications from
                        packaging to
                        Agriculture.
                    </p
                    >
                    <div
                        data-sal="zoom-in"
                        data-sal-delay="100"
                        data-sal-easing="easeInExpo"
                        className="py-10 text-center col-md-12 d-flex flex-column justify-content-center align-items-center">
                        <h2 className="display-2">
                            Nonwoven Fabric Range
                        </h2>
                        <ul className="text-start icon-list fs-18 bullet-primary">
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    We are an IKEA approved sub-supplier, adhering to strict quality standards.
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    GSM range 10 - 150
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    16 Standard colours plus customisation.
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    1.6m (63"), 2.4m (94"), 3.2m (126") Widths available.
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    Water absorbent (hydrophilic) fabric
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    Microporous laminated fabric
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    Waterproof laminated fabric
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    3 Layer sandwich fabric
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    UV stabilised fabrics
                                </span>
                            </li>
                            <li>
                                <span>
                                    <i className="bi bi-chevron-double-right text-orange"/>
                                </span>
                                <span>
                                    Perforated rolls with high precision
                                </span>
                            </li>
                        </ul>
                    </div
                    >
                    <div
                        className="py-md-5 col-lg-12 table-responsive d-flex flex-column justify-content-center align-items-center"
                    >
                        <h2 className="display-2">Fabric Properties</h2>
                        <table style={{'overflow-x': 'auto'}} className="table table-hover text-center table-bordered">
                            <thead>
                            <tr className="text-orange">
                                <th scope="col" colSpan={1}>Weight</th>
                                <th scope="col" colSpan={2}>Tensile Strength</th>
                                <th scope="col" colSpan={2}>Elongation</th>
                                <th scope="col" colSpan={2}>Tensile Strength</th>
                                <th scope="col" colSpan={2}>Elongation</th>
                            </tr>
                            <tr>
                                <th scope="col" colSpan={1}>GSM</th>
                                <th scope="col" colSpan={2}>N / 5 cm</th>
                                <th scope="col" colSpan={2}>%</th>
                                <th scope="col" colSpan={2}>lbs</th>
                                <th scope="col" colSpan={2}>%</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td colSpan={1}>40.3 - 90</td>
                                <td colSpan={2}>EDANA 20.2 - 89</td>
                                <td colSpan={2}>EDANA 20.2 - 89</td>
                                <td colSpan={2}>ASTM D 5035 - 95</td>
                                <td colSpan={2}>ASTM D 5035 – 95</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>MD</td>
                                <td>CD</td>
                                <td>MD</td>
                                <td>CD</td>
                                <td>MD</td>
                                <td>CD</td>
                                <td>MD</td>
                                <td>CD</td>
                            </tr>
                            <tr>
                                <td>15</td>
                                <td>34</td>
                                <td>16</td>
                                <td colSpan={2}>70 - 120</td>
                                <td>7.6</td>
                                <td>3.6</td>
                                <td colSpan={2}>70 - 120</td>
                            </tr>
                            <tr>
                                <td>16</td>
                                <td>36</td>
                                <td>17</td>
                                <td colSpan={2}>70 - 120</td>
                                <td>8.0</td>
                                <td>3.8</td>
                                <td colSpan={2}>70 - 120</td>
                            </tr>
                            <tr>
                                <td>17</td>
                                <td>38</td>
                                <td>19</td>
                                <td colSpan={2}>70 - 120</td>
                                <td>8.5</td>
                                <td>4.3</td>
                                <td colSpan={2}>70 - 120</td>
                            </tr>
                            <tr>
                                <td>18</td>
                                <td>40</td>
                                <td>20</td>
                                <td colSpan={2}>70 - 120</td>
                                <td>8.9</td>
                                <td>4.5</td>
                                <td colSpan={2}>70 - 120</td>
                            </tr>
                            <tr>
                                <td>20</td>
                                <td>44</td>
                                <td>22</td>
                                <td colSpan={2}>70 - 120</td>
                                <td>9.8</td>
                                <td>5.0</td>
                                <td colSpan={2}>70 - 120</td>
                            </tr>
                            <tr>
                                <td>25</td>
                                <td>52</td>
                                <td>26</td>
                                <td colSpan={2}>90 - 140</td>
                                <td>14.4</td>
                                <td>7.4</td>
                                <td colSpan={2}>90 - 140</td>
                            </tr>
                            <tr>
                                <td>30</td>
                                <td>64</td>
                                <td>33</td>
                                <td colSpan={2}>90 - 140</td>
                                <td>14.4</td>
                                <td>7.4</td>
                                <td colSpan={2}>90 - 140</td>
                            </tr>
                            <tr>
                                <td>40</td>
                                <td>85</td>
                                <td>48</td>
                                <td colSpan={2}>90 - 140</td>
                                <td>19.1</td>
                                <td>10.8</td>
                                <td colSpan={2}>90 - 140</td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>115</td>
                                <td>62</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>25.9</td>
                                <td>14.0</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>60</td>
                                <td>140</td>
                                <td>78</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>31.5</td>
                                <td>17.5</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>70</td>
                                <td>159</td>
                                <td>92</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>35.7</td>
                                <td>20.7</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>80</td>
                                <td>177</td>
                                <td>105</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>35.7</td>
                                <td>20.7</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>90</td>
                                <td>185</td>
                                <td>116</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>39.8</td>
                                <td>23.6</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>100</td>
                                <td>198</td>
                                <td>131</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>44.5</td>
                                <td>29.5</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>110</td>
                                <td>210</td>
                                <td>139</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>47.2</td>
                                <td>31.3</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>120</td>
                                <td>218</td>
                                <td>145</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>49</td>
                                <td>32.6</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>130</td>
                                <td>224</td>
                                <td>149</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>50.3</td>
                                <td>33.5</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>140</td>
                                <td>228</td>
                                <td>151</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>51.3</td>
                                <td>34.0</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            <tr>
                                <td>150</td>
                                <td>232</td>
                                <td>153</td>
                                <td colSpan={2}>90 - 160</td>
                                <td>52.2</td>
                                <td>34.4</td>
                                <td colSpan={2}>90 - 160</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
            <div className="pb-15 container justify-content-center align-items-center">
                <div className="grid grid-view text-center">
                    <div className="row gx-md-8 gy-10 gy-md-13">
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={ppspun} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Spunbond Fabric
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                100% virgin PP
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Strong and Resilient
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Soft hand feel
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={laminated} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Laminated Spunbond Fabric
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                PP and PE lamination
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Water proof
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Strong &amp; safe
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={microporous} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Microporous Breathable Laminates
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Soft breathable PE film
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Strong PP fabric base
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                High breathability
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                ASTM 1670 pass
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                class I, II, III
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={hydro} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Hydrophilic
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Water absorbent
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                High rate of absorption
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Soft hand feel
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                High strength
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Medical &amp; Agriculture usage
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={flame} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Flame Retardant
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                For use in automobiles, airlines etc.
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Standard / Customised packing available
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={uvprot} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        UV Protected
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                High UV protection
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                For use in agriculture
                                                &amp; home improvement
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={pocket} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Pocket Springs
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Thickness – customized as per requirement
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Colour – white / any colour
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Material – Pocket spring
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Dimension – customer size as per requirement
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Ergonomic design spring, soft action, Eco fresh advantage, All season mattress
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Usage – Hotel mattress
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={perforated} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Perforated Fabrics
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                For use in bed sheet rolls, bedding &amp; furniture industry
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                High precision ± ¼“
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Material – Pocket spring
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Easy tear away
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="lift card">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={scrims} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Mattress Scrims
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                The provided fabric is well woven using 100% genuine threads with the help of the latest machinery.
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                4” 5” 6” 8”
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Excellent finish
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Tear resistance
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Elegant design
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default FabTechPage